import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationSettings, UpdateNotificationSettings } from '../models/notification-settings.model';

export interface INotificationSettingsRepository {
  get(organizationId: number): Observable<NotificationSettings>;
  update(organizationId: number, request: UpdateNotificationSettings): Observable<NotificationSettings>;
  sendTest(organizationId: number): Observable<void>;
}

export const NOTIFICATION_SETTINGS_REPOSITORY =
  new InjectionToken<INotificationSettingsRepository>('INotificationSettingsRepository');
